window.ocuRelatedChairs = {
  async load(root) {
    const family = root.dataset.chairProfile.split('|')[0];
    const familyQueries = {
      'bariatric-guest': '(title:bariatric OR tag:"Big And Tall Chairs" OR tag:"Heavy Duty Chairs" OR product_type:"Guest Chair")',
      'hip-patient': '(title:"Hip Patient" OR title:"Hip-Patient")',
      task: '(tag:"Computer Task Chairs" OR tag:"Task Chairs" OR product_type:"Mesh Chair" OR product_type:"Task Chair" OR product_type:"Office Chair" OR product_type:"Home Office Chair" OR product_type:"Desk Chairs" OR product_type:"Leather Office Chair" OR product_type:"Mid Back Desk Chair" OR product_type:"Managers Chairs" OR product_type:"Fabric Office Chair" OR title:office OR title:task OR title:managers OR title:bankers)',
      drafting: '(tag:"Drafting Chairs" OR product_type:"Drafting Chair" OR title:drafting)',
      guest: '(tag:"Guest Chairs" OR product_type:"Guest Chair" OR product_type:"Reception Chair" OR title:guest OR title:visitor OR title:reception OR title:"Waiting Room")',
      stacking: '(tag:"Stacking Chairs" OR title:stacking OR title:stackable OR title:nesting)',
      folding: '(product_type:"Folding Chair" OR title:folding)',
      '24-hour': '(tag:"24 Hour Chairs" OR title:"24 Hour" OR title:"24-Hour" OR title:"24/7")',
      'big-tall': '(tag:"Big And Tall Chairs" OR product_type:"Big & Tall Chairs" OR title:"Big and Tall" OR title:"Big & Tall")',
      executive: '(tag:"Executive Chairs" OR product_type:"Executive Chair" OR title:executive)',
      accent: '(product_type:"Accent Chair" OR product_type:"Club Chair" OR product_type:"Arm Chairs" OR title:accent OR title:lounge OR title:club OR title:recliner)',
      dining: '(product_type:"Dining Chair" OR title:dining)',
      barstool: '(title:barstool OR title:"Bar Stool" OR title:"Counter Stool")',
      'backless-stool': '(title:backless)',
      kneeling: '(title:kneeling)',
      gaming: '(title:gaming OR product_type:"Gaming Chair")'
    };
    const productTypeQuery = root.dataset.productType ? 'product_type:' + JSON.stringify(root.dataset.productType) : '';
    const familyQuery = familyQueries[family] || productTypeQuery;
    if (!familyQuery) return false;
    const url = new URL(root.dataset.searchUrl, location.origin);
    url.searchParams.set('q', familyQuery);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('options[unavailable_products]', 'hide');
    url.searchParams.set('section_id', 'related-chair-search');
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const desired = Math.max(1, Math.min(20, Number(root.dataset.chairLimit) || 10));
    const candidates = new Map();
    const visited = new Set();
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    let next = url;
    try {
      while (next && !visited.has(next.href) && visited.size < 20) {
        visited.add(next.href);
        const response = await fetch(next, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) break;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-related-chair-results]');
        if (!results) break;
        results.querySelectorAll('[data-chair-id]').forEach(card => {
          if (card.dataset.chairId !== root.dataset.chairId &&
              card.dataset.chairProfile === root.dataset.chairProfile) {
            candidates.set(card.dataset.chairId, card);
          }
        });
        if (candidates.size >= desired) break;
        const nextPath = results.dataset.nextUrl;
        next = nextPath ? new URL(nextPath, location.origin) : null;
        if (next && next.origin !== location.origin) break;
        if (next) {
          next.searchParams.set('section_id', 'related-chair-search');
          if (previewTheme) next.searchParams.set('preview_theme_id', previewTheme);
        }
      }
    } catch (error) {
      if (error.name !== 'AbortError') root.dataset.chairSearchFailed = 'true';
    } finally {
      clearTimeout(timer);
    }
    const sourcePrice = Number(root.dataset.chairPrice);
    const cards = [...candidates.values()].sort((a, b) => {
      const aDistance = Math.abs(Number(a.dataset.chairPrice) - sourcePrice);
      const bDistance = Math.abs(Number(b.dataset.chairPrice) - sourcePrice);
      return aDistance - bDistance ||
        Number(b.dataset.chairVendor === root.dataset.chairVendor) - Number(a.dataset.chairVendor === root.dataset.chairVendor) ||
        a.dataset.chairId.localeCompare(b.dataset.chairId);
    }).slice(0, desired);
    const grid = root.querySelector('.products-grid');
    cards.forEach(card => {
      card.querySelectorAll('.wow').forEach(item => {
        item.classList.remove('wow');
        item.style.visibility = 'visible';
      });
      card.querySelectorAll('img[data-src]').forEach(img => {
        img.src = img.dataset.src;
        img.loading = 'lazy';
        img.classList.remove('lazyload');
      });
      grid.appendChild(card);
    });
    root.hidden = cards.length === 0;
    root.dataset.chairMatchCount = String(cards.length);
    return cards.length > 0;
  }
};
